module.exports = __webpack_public_path__ + "img/fakecorporate.2f55ec61.webp";